const BEIJING_TIME_ZONE = 'Asia/Shanghai'

const pad2 = (value) => String(value).padStart(2, '0')

const formatParts = (date) => {
  const parts = new Intl.DateTimeFormat('zh-CN', {
    timeZone: BEIJING_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(date)
  const values = Object.fromEntries(parts.map((part) => [part.type, part.value]))
  return `${values.year}-${values.month}-${values.day} ${values.hour}:${values.minute}`
}

/**
 * 数据中心统一北京时间显示：YYYY-MM-DD HH:mm。
 * - 带 Z/±HH:mm 的时间先换算到 Asia/Shanghai。
 * - 无时区的 YYYY-MM-DD HH:mm(:ss) 按平台返回的北京时间直接解释。
 * - 兼容秒/毫秒时间戳。
 */
export const formatBeijingDateTime = (value, fallback = '—') => {
  if (value == null || value === '') return fallback

  const raw = String(value).trim()
  if (!raw) return fallback

  if (/^\d{10,13}$/.test(raw)) {
    const number = Number(raw)
    const date = new Date(raw.length === 10 ? number * 1000 : number)
    return Number.isNaN(date.getTime()) ? fallback : formatParts(date)
  }

  const naive = raw.match(
    /^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{1,2}):(\d{2})(?::\d{2}(?:\.\d+)?)?)?$/,
  )
  if (naive) {
    const [, year, month, day, hour = '00', minute = '00'] = naive
    return `${year}-${month}-${day} ${pad2(hour)}:${minute}`
  }

  const date = new Date(raw)
  return Number.isNaN(date.getTime()) ? raw.replace('T', ' ').slice(0, 16) : formatParts(date)
}
